<template>
  <div class="proAndSolut">
    <v-publiceTit :titleObj='titleObj'></v-publiceTit>
    <div class="proCon">
      <div class="tabTitle">
        <ul id="myTab" class="nav nav-tabs">
          <li class="active">
            <a href="#recruit" data-toggle="tab">采招系统<div class="tabLine"></div></a>
          </li>
          <li>
            <a href="#coordination" data-toggle="tab">协同系统<div class="tabLine"></div></a>
          </li>
          <li>
            <a href="#mro" data-toggle="tab">企业电商<div class="tabLine"></div></a>
          </li>
          <li>
            <a href="#supplierMangement" data-toggle="tab">供应商管理<div class="tabLine"></div></a>
          </li>
          <li>
            <a href="#credit" data-toggle="tab">征信服务<div class="tabLine"></div></a>
          </li>
        </ul>
      </div>
      <div class="tabCon">
        <div id="myTabContent" class="tab-content">
          <div class="clearfix tabConBox tab-pane in active" id="recruit">
            <div class="col-sm-4 col-md-4 col-lg-4 imgBox hidden-xs">
              <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/proAndSolut_img01.png" alt="">
            </div>
            <div class="tabRight col-xs-12 col-sm-7 col-md-7 col-lg-7 pull-right">
              <h3 class="hidden-xs">采招系统</h3>
              <p>围绕企业采购寻源业务，支持招标采购、询报价、电子竞价、直接委托等多种寻源业务形式线上化。
                帮助您的企业对内实现集中管控、降本增效，对外实现高效协作、阳光采购。</p>
              <div class="imgBox hidden-sm hidden-md hidden-lg">
                <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/proAndSolut_img01.png" alt="">
              </div>
              <button type="button" @click="viewRecruitment()" class="hidden-xs hidden-sm btn btn-default btn-lg">前往查看</button>
              <button type="button" @click="viewRecruitment()" class="hidden-md hidden-lg btn btn-default btn-sm">MORE</button>
            </div>
          </div>
          <div class="clearfix tabConBox tab-pane" id="coordination">
            <div class="col-sm-4 col-md-4 col-lg-4 imgBox hidden-xs">
              <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/proAndSolut_img02.png" alt="">
            </div>
            <div class="tabRight col-xs-12 col-sm-7 col-md-7 col-lg-7 pull-right">
              <h3 class="hidden-xs">协同系统</h3>
              <p>覆盖采购申请发起、采购订单创建，供应商确认订单、发货，采购商收货、入库、履约评价的全流程闭环，提供线上协同作业解决方案，实现 “全业务流程可视化、全采购数据可视化、全操作流程一体化”的采购订单端到端服务</p>
              <div class="imgBox hidden-sm hidden-md hidden-lg">
                <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/proAndSolut_img02.png" alt="">
              </div>
              <button type="button" class="hidden-xs hidden-sm btn btn-default btn-lg" @click="viewSupplier()">前往查看</button>
              <button type="button" class="hidden-md hidden-lg btn btn-default btn-sm" @click="viewSupplier()">MORE</button>
            </div>
          </div>
          <div class="clearfix tabConBox tab-pane" id="mro">
            <div class="col-sm-4 col-md-4 col-lg-4 imgBox hidden-xs"><img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/proAndSolut_img01.png" alt=""></div>
            <div class="tabRight col-xs-12 col-sm-7 col-md-7 col-lg-7 pull-right">
              <h3 class="hidden-xs">企业电商</h3>
              <p>整合过百万种非核心物料的电商式采购平台，覆盖工业品MRO、物业管理物资、行政用品、办公用品等产品。</p>
              <div class="imgBox hidden-sm hidden-md hidden-lg">
                <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/proAndSolut_img01.png" alt="">
              </div>
              <button type="button" class="hidden-xs hidden-sm btn btn-default btn-lg" @click="viewMro()"><a>前往查看</a></button>
              <button type="button" class="hidden-md hidden-lg btn btn-default btn-sm" @click="viewMro()"><a>MORE</a></button>
            </div>
          </div>
          <div class="clearfix tabConBox tab-pane" id="supplierMangement">
            <div class="col-sm-4 col-md-4 col-lg-4 imgBox hidden-xs"><img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/proAndSolut_img04.png" alt=""></div>
            <div class="tabRight col-xs-12 col-sm-7 col-md-7 col-lg-7 pull-right">
              <h3 class="hidden-xs">供应商管理</h3>
              <p>一链供应商管理平台定位于各个行业，为入驻采购企业提供丰富的平台供应商资源，支持自定义企业供应商库。 提供供应商全生命周期管理工具，同时对接第三方征信接口，让企业全方位了解供应商的征信级别，舆情动态。同时可与一链网其他产品无缝组合，支撑业务过程管控，渗透供方管理各场景应用。</p>
              <div class="imgBox hidden-sm hidden-md hidden-lg">
                <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/proAndSolut_img04.png" alt="">
              </div>
              <button type="button" class="hidden-xs hidden-sm btn btn-default btn-lg" @click="viewSupplierManage()">前往查看</button>
              <button type="button" class="hidden-md hidden-lg btn btn-default btn-sm" @click="viewSupplierManage()">MORE</button>
            </div>
          </div>
          <div class="clearfix tabConBox tab-pane" id="credit">
            <div class="col-sm-4 col-md-4 col-lg-4 imgBox hidden-xs"><img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/proAndSolut_img05.png" alt=""></div>
            <div class="tabRight col-xs-12 col-sm-7 col-md-7 col-lg-7 pull-right">
              <h3 class="hidden-xs">征信服务</h3>
              <p>信用控制风险，为采购企业获得更多优质供应商，
                供应商秀出自己的诚信和实力，信用换取更多商机。
                为构建阳光诚信交易环境，促成买家卖家高效达成交易，一链网特别推出征信增值服务。
                本服务通过对接权威第三方征信机构旨为企业经营现状及综合实力提供评估证明</p>
              <div class="imgBox hidden-sm hidden-md hidden-lg">
                <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/proAndSolut_img05.png" alt="">
              </div>
              <button type="button" @click="viewCredit()" class="hidden-xs hidden-sm btn btn-default btn-lg">前往查看</button>
              <button type="button" @click="viewCredit()" class="hidden-md hidden-lg btn btn-default btn-sm">MORE</button>
            </div>
          </div>
        </div>
        <div class="tabBg"></div>
      </div>
    </div>
  </div>
</template>
<script>
import publiceTit from '@/components/publiceTit'
export default {
  props: ['supplierManagerUrl','coordinationManagerUrl','coordinationSupplierUrl','recruitPurchaserUrl','recruitSupplierUrl','mroShoppingMallUrl','coordinationSupplierAuthFlag','coordinationSystemAuthFlag','supplierManagerAuthFlag'],
  data () {
    return {
      titleObj: {name: '产品与解决方案', eng: 'PRODUCTS AND SOLUTIONS'}
    }
  },
  components: {
    'v-publiceTit': publiceTit
  },
  created () {
    this.tab()
  },
  mounted () {
    this.ulWidth();
    this.resizeUlWidth();
    this.hoverTabShow()
  },
  methods: {
    tab () {
      $('#myTab li:eq(1) a').tab('show')
    },
    hoverTabShow(){
      $('#myTab a').mouseover(function (e) {
        e.preventDefault()
        $(this).tab('show')
      })
    },
    ulWidth () {
      // 动态计算ul的宽度
      let scrollwrap = $('#myTab')
      let lis = $('li', scrollwrap)
      let sum = 0
      // 遍历每一个li元素
      lis.each(function (index, el) {
        let _el = $(el)
        // width 宽度 代表的是内容的宽度 innerWidth 代表的是padding + width
        // outerWidth 代表的是border+padding+width
        sum += _el.width()
      })
      // 将累加的值直接复制给ul元素
      scrollwrap.width(sum + 7)
    },
    resizeUlWidth(){
      $(window).resize(() => {
        if($('.proAndSolut').width() < 750){
          this.ulWidth();
        }else{
          $('#myTab').width('auto')
        }
      })
    },
    goToHref(val){
      this.$router.push({path: val})
    },
    viewCredit(){
      this.$router.push({path:'/creditService'});
    },
    viewSupplier(){
      this.coordinationSupplierAuthFlag = this.getToken('coordinationSupplierAuthFlag');
      this.coordinationSystemAuthFlag = this.getToken('coordinationSystemAuthFlag');
      if(this.getToken('isLogin') == ''){
        this.$router.push({path:'/supplyChain'});
      }else if(this.getToken('examineStatus') == '200'){
        this.$router.push({path:'/supplyChain'});
      }else if(this.getToken('examineStatus') == '300'){
        this.$router.push({path:'/supplyChain'});
      }
      else if(this.getCookie("COMPANY_COMPLETE_STATUS_"+this.getCookie("justId")) == "1"){
        this.$alert('<p>企业变更信息已提交，请耐心等待审核结果</p>', '', {
            dangerouslyUseHTMLString: true,
            customClass:'mobileText',
            center: true,
            showClose:false
          });
      }else if(this.getToken('checkFlag') == 200 && this.getCookie('TALK_LATER_'+this.getCookie('justId'))>=14){
        this.$confirm('请立即完善企业信息', '您的企业信息不完整，无法进入项目。', {
          cancelButtonClass:'cancelBtn',
          customClass:'mobileText',
          cancelButtonText: '以后再说',
          confirmButtonText: '点我补全',
          center: true
        }).then(() => {
          this.$router.push({path:'/inforPerfection'});
        }).catch(() => {
            this.$axios.post('/onelink.mdata.main.api/web/operateTalkLater', {
            }).then((res) => {
              this.data = res.data;
              this.removeCookie('TALK_LATER_'+this.data.userId);
              this.setCookie('TALK_LATER_'+this.data.userId,this.data.instanceDay);
            });
        });
      }
      else{
        if(this.getToken('userTag') == '10'){
          if(this.coordinationSupplierAuthFlag == '100'){
            window.location.href = this.coordinationSupplierUrl;
          }else{
            this.$router.push({path:'/supplyChain'});
          }
        }else if(this.getToken('userTag') == '20'){
          if(this.coordinationSystemAuthFlag == '100'){
            window.location.href = this.coordinationManagerUrl;
          }else{
            this.$router.push({path:'/supplyChain'});
          }
        }else{
          this.$router.push({path:'/supplyChain'});
        }
      }
      
    },
    viewRecruitment(){
      if(this.getToken('isLogin') == ''){
        this.$router.push({path:'/recruitmentSystem'});
      }else if(this.getToken('examineStatus') == '200'){
        this.$router.push({path:'/recruitmentSystem'});
      }else if(this.getToken('examineStatus') == '300'){
        this.$router.push({path:'/recruitmentSystem'});
      }
      else if(this.getCookie("COMPANY_COMPLETE_STATUS_"+this.getCookie("justId")) == "1"){
        this.$alert('<p>企业变更信息已提交，请耐心等待审核结果</p>', '', {
            dangerouslyUseHTMLString: true,
            customClass:'mobileText',
            center: true,
            showClose:false
          });
      }else if(this.getToken('checkFlag') == 200 && this.getCookie('TALK_LATER_'+this.getCookie('justId'))>=14){
        this.$confirm('请立即完善企业信息', '您的企业信息不完整，无法进入项目。', {
          cancelButtonClass:'cancelBtn',
          customClass:'mobileText',
          cancelButtonText: '以后再说',
          confirmButtonText: '点我补全',
          center: true
        }).then(() => {
          this.$router.push({path:'/inforPerfection'});
        }).catch(() => {
            this.$axios.post('/onelink.mdata.main.api/web/operateTalkLater', {
            }).then((res) => {
              this.data = res.data;
              this.removeCookie('TALK_LATER_'+this.data.userId);
              this.setCookie('TALK_LATER_'+this.data.userId,this.data.instanceDay);
            });
        });
      }
      else{
        if(this.getToken('userTag') == '10'){
          window.location.href = this.recruitSupplierUrl;
        }else if(this.getToken('userTag') == '20'){
          window.location.href = this.recruitPurchaserUrl;
        }else{
          this.$router.push({path:'/recruitmentSystem'});
        }
      }
    },
    viewSupplierManage(){
      this.supplierManagerAuthFlag = this.getToken('supplierManagerAuthFlag');
      if(this.getToken('isLogin') ==''){
        this.$router.push({path:'/supplierManagement'});
      }else if(this.getToken('examineStatus') == '200'){
        this.$router.push({path:'/supplierManagement'});
      }else if(this.getToken('examineStatus') == '300'){
        this.$router.push({path:'/supplierManagement'});
      }
      else if(this.getCookie("COMPANY_COMPLETE_STATUS_"+this.getCookie("justId")) == "1"){
        this.$alert('<p>企业变更信息已提交，请耐心等待审核结果</p>', '', {
            dangerouslyUseHTMLString: true,
            customClass:'mobileText',
            center: true,
            showClose:false
          });
      }else if(this.getToken('checkFlag') == 200 && this.getCookie('TALK_LATER_'+this.getCookie('justId'))>=14){
        this.$confirm('请立即完善企业信息', '您的企业信息不完整，无法进入项目。', {
          cancelButtonClass:'cancelBtn',
          customClass:'mobileText',
          cancelButtonText: '以后再说',
          confirmButtonText: '点我补全',
          center: true
        }).then(() => {
          this.$router.push({path:'/inforPerfection'});
        }).catch(() => {
            this.$axios.post('/onelink.mdata.main.api/web/operateTalkLater', {
            }).then((res) => {
              this.data = res.data;
              this.removeCookie('TALK_LATER_'+this.data.userId);
              this.setCookie('TALK_LATER_'+this.data.userId,this.data.instanceDay);
            });
        });
      }
      else{
        if(this.supplierManagerAuthFlag=='100'){
          window.location.href = this.supplierManagerUrl;
        }else{
          this.$router.push({path:'/supplierManagement'});
        }
      }
    },
    viewMro(){
      window.location.href = this.mroShoppingMallUrl;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/proAndSolut/index.vue